module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Harry Harrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Harry Harrison (1925–2012) began writing science fiction in the 1950s and remains one of the top-selling authors in the genre. Harrison is best known for his Stainless Steel Rat, Deathworld, and West of End series, as well as "), _c('I', [_vm._v("Make Room! Make Room!")]), _vm._v(", which was turned into the movie "), _c('I', [_vm._v("Soylent Green ")]), _vm._v("starring Charlton Heston and Edward G. Robinson. His novels have appeared on the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestseller list, and in 2009 he was awarded the Damon Knight SF Grand Master Award by the Science Fiction Writers of America.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bClC4p/tc-custom/9781429967280.jpg?1733034792146",
      "alt": "This image is the cover for the book Harry Harrison! Harry Harrison!"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Harry Harrison! Harry Harrison!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In "), _c('i', [_vm._v("Harry Harrison! Harry Harrison!")]), _vm._v(" are the recollections of one of the grand masters of science fiction, on his storied career as a celebrated author and on his relationships with other luminaries in the field. This memoir is filled with all the humor and irreverence Harry Harrison's readers have come to expect from the "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestselling author of the uproarious "), _c('i', [_vm._v("Stainless Steel Rat")]), _vm._v(" series. This also includes black and white photos spanning his sixty-year career."), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0